import React, { useEffect, useState } from "react";
import classes from "./AccountSlider.module.css";
import { useSelector } from "react-redux";
import { postApiData } from "../../../../components/utilities/nodeApiServices";
import { apiList } from "../../../../components/utilities/nodeApiList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CheipImg from "../../../../assets/Banks/chip.svg"
import { numberCommaFormat } from "../../../../components/common/commonArray";
const AccountSlider = ({ accList }) => {
  const { user } = useSelector((state) => state.auth);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [balances, setBalances] = useState({});
  const [backgroundImage, setBackgroundImage] = useState(null);

  const bankNames = process.env.REACT_APP_FLAVOUR;
  useEffect(() => {
    const importedImage = async () => {
      // const backgroundimages = await import(
      //   `../../assets/Banks/${bankNames}/images/CardBankLogo.svg`
      // );
      const backgroundimages = await import(
        `../../../../assets/Banks/${bankNames}/images/CardBankLogo.svg`
      );

      setBackgroundImage(backgroundimages.default);

    };
    importedImage();
  }, [bankNames]);
  const cards = accList.map((acc) => ({
    type: "account",
    accountNumber: acc.accNo,
    accountType: acc.accType,
    balance: acc.accBal || "XXXXXXX",
    name: acc.accName,
  }));

  cards.push({ type: "add" });

  const maxIndex = cards.length > 1 ? cards.length - 2 : 0;

  const handleDotClick = (index) => {
    if (index >= 0 && index <= maxIndex) {
      setCurrentIndex(index);
    }
  };

  const fetchBalance = async (accNo) => {
    if (balances[accNo]?.visible) {
      setBalances((prev) => ({
        ...prev,
        [accNo]: { ...prev[accNo], visible: false },
      }));
      return;
    }

    setBalances((prev) => ({
      ...prev,
      [accNo]: {
        ...prev[accNo],
        loading: true,
        visible: false,
      },
    }));

    try {
      const payload = {
        accNo,
        custNo: user?.userId,
        sessionId: user?.sessionId,
      };
      const response = await postApiData(apiList.FETCHBAL, payload);
      const balance = response?.data?.accBal ?? "0.00";

      setBalances((prev) => ({
        ...prev,
        [accNo]: {
          amount: response?.status === true ? balance : "XXXXX",
          visible: response?.status === true,
          loading: false,
        },
      }));
    } catch (err) {
      console.error("Error fetching balance:", err);
      setBalances((prev) => ({
        ...prev,
        [accNo]: { amount: "XXXXX", visible: false, loading: false },
      }));
    }
  };




  return (
    <div className={classes.sliderContainer}>
      <div
        className={classes.sliderTrack}
        style={{
          transform: `translateX(-${currentIndex * 52}%)`,
        }}
      >
        {cards.map((card, index) => (
          <div className={classes.card} key={index}>
            {card.type === "account" ? (
              <div className={classes.accountCard}>
                <img src={backgroundImage} className={classes.CheipImg} />


                <div className={classes.accountHeader}>
                  <span>{card.accountNumber}</span>
                  <span>{card.accountType}</span>
                </div>
                <div className={classes.balanceSection}>
                  <div className={classes.balanceLabel}>Available Balance</div>
                  {/* <div className={classes.amoutBtn}>
                    <div className={classes.balanceAmount}>
                      {balances[card.accountNumber]?.loading ? (
                        <div className={classes.dotLoader}>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      ) : (
                        `₹ ${balances[card.accountNumber]?.visible
                          ? balances[card.accountNumber].amount
                          : "XXXXX"
                        }`
                      )}

                    </div>
                    <div
                      className={classes.iconBtn}
                      onClick={() => fetchBalance(card.accountNumber)}
                    >
                      {balances[card.accountNumber]?.loading ? null : balances[card.accountNumber]?.visible ? (
                        <VisibilityOffIcon fontSize="small" />
                      ) : (
                        <VisibilityIcon fontSize="small" />
                      )}
                    </div>
                  </div> */}
                  <div className={classes.amoutBtn}>
                    <div className={classes.balanceAmount}>
                      {balances[card.accountNumber]?.loading ? (
                        <div className={classes.dotLoader}>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      ) : (
                        balances[card.accountNumber]?.visible
                          ? numberCommaFormat(balances[card.accountNumber].amount)
                          : "₹ XXXXX"
                      )}
                    </div>

                    <div
                      className={classes.iconBtn}
                      onClick={() => fetchBalance(card.accountNumber)}
                    >
                      {balances[card.accountNumber]?.loading ? null : balances[card.accountNumber]?.visible ? (
                        <VisibilityOffIcon fontSize="small" />
                      ) : (
                        <VisibilityIcon fontSize="small" />
                      )}
                    </div>
                  </div>


                </div>
                <div className={classes.accountName}>{card.name}</div>
              </div>
            ) : (
              <div className={classes.addAccountCard}>
                <div className={classes.plus}>+</div>
                <p>Add Account</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className={classes.sliderDots}>
        {Array.from({ length: maxIndex + 1 }).map((_, idx) => (
          <button
            key={idx}
            className={`${classes.dot} ${idx === currentIndex ? classes.active : ""
              }`}
            onClick={() => handleDotClick(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default AccountSlider;
